<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap fill-height v-if="appUser === 'admin'">
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down" v-if="$route.name !== 'mapping'">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <!-- Section Toggle -->
          <div class="sidebar-section-toggle">
            <button
              class="section-btn"
              :class="{ active: activeSection === 'hwc' }"
              @click="setActiveSection('hwc')"
            >HWC</button>
            <button
              class="section-btn"
              :class="{ active: activeSection === 'sarpa' }"
              @click="setActiveSection('sarpa')"
            >SARPA</button>
          </div>

          <div class="sidebar-divider"></div>

          <!-- HWC Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
            <div
              v-for="item in items"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>

            <!-- Dynamic Data group -->
            <v-list-group class="sidebar-group pt-0 mt-0" no-action>
              <template v-slot:activator>
                <div class="sidebar-item group-activator">
                  <v-icon class="sidebar-icon">{{ dynamic.icon }}</v-icon>
                  <span class="sidebar-label">{{ dynamic.title }}</span>
                </div>
              </template>
              <div
                v-for="child in dynamic.dynamicItems"
                :key="child.title"
                class="sidebar-item sidebar-item--child"
                :class="{ 'sidebar-item--active': $route.path === child.path }"
                @click="$router.push(child.path)"
              >
                <v-icon class="sidebar-icon" style="font-size:14px">mdi-chevron-right</v-icon>
                <span class="sidebar-label">{{ child.title }}</span>
              </div>
            </v-list-group>
          </div>

          <!-- SARPA Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
            <div
              v-for="item in sarpadashboard"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0 v-if="activeSection === 'hwc'">
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0 v-if="activeSection === 'sarpa'">
            <SarpaAppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center style="background-color: #eef3ea">
              <v-flex xs12>
                <v-card min-height="100vh" :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap fill-height v-else>
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down" v-if="$route.name !== 'mapping'">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <!-- Section Toggle -->
          <div class="sidebar-section-toggle">
            <button
              class="section-btn"
              :class="{ active: activeSection === 'hwc' }"
              @click="setActiveSection('hwc')"
            >HWC</button>
            <button
              class="section-btn"
              :class="{ active: activeSection === 'sarpa' }"
              @click="setActiveSection('sarpa')"
            >SARPA</button>
          </div>

          <div class="sidebar-divider"></div>

          <!-- HWC Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
            <div
              v-for="item in SEOCitems"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>

            <!-- Dynamic Data group -->
            <v-list-group class="sidebar-group pt-0 mt-0" no-action>
              <template v-slot:activator>
                <div class="sidebar-item group-activator">
                  <v-icon class="sidebar-icon">{{ dynamic.icon }}</v-icon>
                  <span class="sidebar-label">{{ dynamic.title }}</span>
                </div>
              </template>
              <div
                v-for="child in dynamic.dynamicItems"
                :key="child.title"
                class="sidebar-item sidebar-item--child"
                :class="{ 'sidebar-item--active': $route.path === child.path }"
                @click="$router.push(child.path)"
              >
                <v-icon class="sidebar-icon" style="font-size:14px">mdi-chevron-right</v-icon>
                <span class="sidebar-label">{{ child.title }}</span>
              </div>
            </v-list-group>
          </div>

          <!-- SARPA Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
            <div
              v-for="item in SEOCsarpadashboard"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0 v-if="activeSection === 'hwc'">
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0 v-if="activeSection === 'sarpa'">
            <SarpaAppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center style="background-color: #eef3ea">
              <v-flex xs12>
                <v-card min-height="100vh" :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="deocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Case Report Query</v-card-title>
        <v-card-text>
          Whether there is any case to be reported for the daily report?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleDeocYes">Yes</v-btn>
          <v-btn color="error" text @click="handleDeocNo">No</v-btn>
          <v-btn text @click="deocDialog = false">
            <v-icon>mdi-close</v-icon> Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deocRescueDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Rescue Case Report Query</v-card-title>
        <v-card-text>
          Whether there is any rescue case to be reported for the daily rescue report?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleRescueDeocYes">Yes</v-btn>
          <v-btn color="error" text @click="handleRescueDeocNo">No</v-btn>
          <v-btn text @click="deocRescueDialog = false">
            <v-icon>mdi-close</v-icon> Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppHeader from "@/components/Common/appHeader";
import SarpaAppHeader from "@/components/Common/appHeadersarpa";
import axios from "axios";

export default {
  components: {
    AppHeader,
    SarpaAppHeader
  },
  data() {
    return {
      activeSection: localStorage.getItem('activeSection') || 'hwc',
      items: [
        // {
        //   title: "Dashboard",
        //   icon: "mdi-view-dashboard",
        //   path: "/Admin/admindashboard",
        // },
        {
          title: "Dashboard",
          icon: "mdi-home-analytics",
          path: "/admin/analyticspage",
        },
        {
          title: "Statistics",
          icon: "mdi-chart-bar",
          path: "/admin/hwcanalyticspage",
        },
        {
          title: "Home",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        // {
        //   title: "Report Case",
        //   icon: "mdi-account-plus",
        //   path: "/Admin/reportCase",
        // },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },
        // { title: "Public", icon: "mdi-account-group", path: "/Admin/public" },
        // {
        //   title: "Conflict Reports",
        //   icon: "mdi-source-repository-multiple",
        //   path: "/Admin/ConflictReports",
        // },
        // {
        //   title: "Analytics",
        //   icon: "mdi-home-analytics",
        //   path: "/admin/analyticspage",
        // },

        // {
        //   title: "Common",
        //   icon: "mdi-home-analytics",
        //   path: "/admin/commonanalyticspage",
        // },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Admin/notifications",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/reportGeneration",
        },
        // {
        //   title: "All Reportings",
        //   icon: "mdi-file-chart",
        //   path: "/Admin/myReport",
        // },
        // {
        //   title: "Merged Cases",
        //   icon: "mdi-call-merge",
        //   path: "/Admin/mergedlist",
        // },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Admin/closedcases",
        },
        {
          title: "Map",
          icon: "mdi-map-search-outline",
          path: "/Admin/mapping",
        },
        {
          title: "Add SFEOC User",
          icon: "mdi-account-plus",
          path: "/Admin/emergencyUser",
        },
        { title: "Add DFEOC", icon: "mdi-account-plus-outline", path: "/Admin/adddeoc" },
        { title: "Add RRT", icon: "mdi-account-plus-outline", path: "/Admin/addrrt" },
        { title: "Add Minister", icon: "mdi-account-star-outline", path: "/Admin/addminister" },
        { title: "Add Analyst", icon: "mdi-chart-line", path: "/Admin/addanalyst" },
        // { title: "Add SEOC", icon: "mdi-account-plus", path: "/Admin/addSeoc" },
        // {
        //   title: "Daily Reporting",
        //   icon: "mdi-chart-tree",
        //   path: "/Admin/daily-reporting",
        // },
        {
          title: "Daily Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report",
        },
        // {
        //   title: "Daily Reporting Rescue",
        //   icon: "mdi-chart-tree",
        //   path: "/Admin/daily-reporting-rescue",
        // },
        {
          title: "Daily Rescue Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report-rescue",
        },
        // {
        //   title: "Fencing",
        //   icon: "mdi-fence",
        //   path: "/Admin/fencing-list",
        // },
      ],
      SEOCitems: [
        {
          title: "Dashboard",
          icon: "mdi-home-analytics",
          path: "/admin/analyticspage",
        },
        {
          title: "Statistics ",
          icon: "mdi-chart-bar",
          path: "/admin/hwcanalyticspage",
        },
        {
          title: "Home",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },

        // {
        //   title: "Add SEOC User",
        //   icon: "mdi-account-plus",
        //   path: "/Admin/emergencyUser",
        // },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Admin/notifications",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/reportGeneration",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Admin/closedcases",
        },
        {
          title: "Map",
          icon: "mdi-map-search-outline",
          path: "/Admin/mapping",
        },
        // {
        //   title: "Daily Reporting",
        //   icon: "mdi-chart-tree",
        //   path: "/Admin/daily-reporting",
        // },
        {
          title: "Daily Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report",
        },
        // {
        //   title: "Daily Reporting Rescue",
        //   icon: "mdi-chart-tree",
        //   path: "/Admin/daily-reporting-rescue",
        // },
        {
          title: "Daily Rescue Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report-rescue",
        },
        // { title: "Add DEOC", icon: "mdi-account-plus-outline", path: "/Admin/adddeoc" },
        // { title: "Add RRT", icon: "mdi-account-plus-outline", path: "/Admin/addrrt" },
      ],
      sarpadashboard: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Sarpa/dashboard",
        },
        {
          title: "Statistics ",
          icon: "mdi-chart-bar",
          path: "/admin/sarpaanalyticspage",
        },
        {
          title: "Add Snakes",
          icon: "mdi-plus",
          path: "/addSnakes",
        },
        {
          title: "AI Images",
          icon: "mdi-image",
          path: "/aiImages/snake-types",
        },
        {
          title: "All Users",
          icon: "mdi-account-multiple",
          path: "/usersList",
        },
        // {
        //   title: "New Rescuers",
        //   icon: "mdi-file-plus",
        //   path: "/newrescuerslist",
        // },
        // {
        //   title: "Rescuer List",
        //   icon: "mdi-format-list-bulleted",
        //   path: "/allrescuerlist",
        // },
        // {
        //   title: "Banned Rescuers",
        //   icon: "mdi-file-cancel-outline",
        //   path: "/bannedrescuerlist",
        // },
        {
          title: "Rescuers",
          icon: "mdi-account-group",
          path: "/rescuers",
        },

        {
          title: "Approve All",
          icon: "mdi-check-decagram-outline",
          path: "/approveoperations",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-receipt-clock-outline",
        //   path: "/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-clipboard-check",
        //   path: "/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-invoice-list",
        //   path: "/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-view-list",
        //   path: "/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/approvedoperations",
        // },
        {
          title: "Delete Operations",
          icon: "mdi-delete-alert",
          path: "/deleteoperations",
        },
        {
          title: "Training List",
          icon: "mdi-chair-school",
          path: "/traininglist",
        },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/snakereports",
        },
        {
          title: "Add Snake Experts",
          icon: "mdi-plus",
          path: "/addsnakeexperts",
        },
        {
          title: "Add Hospital",
          icon: "mdi-hospital-building",
          path: "/addhospital",
        },
        {
          title: "View Hospital",
          icon: "mdi-hospital-marker",
          path: "/Viewhospital",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-box-multiple-outline",
          path: "/identificationhelp",
        },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/excelreport",
        },
        {
          title: "Badge Levels",
          icon: "mdi-medal-outline",
          path: "/badgelevels",
        },
        {
          title: "Ratings Operations",
          icon: "mdi-star-outline",
          path: "/ratingsoperations",
        },
        //website contents
        {
          title: "About SARPA Rescuers",
          icon: "mdi-account-group-outline",
          path: "/about-sarpa-rescuers",
        },
        {
          title: "Privacy Policy",
          icon: "mdi-shield-lock-outline",
          path: "/manage-privacy-policy",
        },
        {
          title: "Terms & Conditions",
          icon: "mdi-file-document-outline",
          path: "/terms-and-conditions",
        },
        {
          title: "About Us",
          icon: "mdi-information-outline",
          path: "/about-us",
        },
        {
          title: "Mission & Vision",
          icon: "mdi-eye-outline",
          path: "/mission-and-vision",
        },
        {
          title: "Back Story",
          icon: "mdi-history",
          path: "/back-story",
        }


        // {
        //   title: "Approve Hospital",
        //   icon: "mdi-check-decagram-outline",
        //   path: "/approvehospital",
        // },
      ],
      SEOCsarpadashboard: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Sarpa/dashboard",
        },
        {
          title: "Statistics ",
          icon: "mdi-chart-bar",
          path: "/admin/sarpaanalyticspage",
        },
        {
          title: "Add Snakes",
          icon: "mdi-plus",
          path: "/addSnakes",
        },
        {
          title: "All Users",
          icon: "mdi-account-multiple",
          path: "/usersList",
        },
        {
          title: "New Rescuers",
          icon: "mdi-file-plus",
          path: "/newrescuerslist",
        },
        {
          title: "Rescuer List",
          icon: "mdi-format-list-bulleted",
          path: "/allrescuerlist",
        },
        {
          title: "Banned Rescuers",
          icon: "mdi-file-cancel-outline",
          path: "/bannedrescuerlist",
        },
        {
          title: "Approve All",
          icon: "mdi-check-decagram-outline",
          path: "/approveoperations",
        },
        {
          title: "Pending Operations",
          icon: "mdi-receipt-clock-outline",
          path: "/pendingoperations",
        },
        {
          title: "Assigned Operations",
          icon: "mdi-clipboard-check",
          path: "/assignedoperations",
        },
        {
          title: "Rescued Operations",
          icon: "mdi-invoice-list",
          path: "/rescuedoperations",
        },
        {
          title: "Released Operations",
          icon: "mdi-view-list",
          path: "/releasedoperations",
        },
        {
          title: "Approved Operations",
          icon: "mdi-playlist-check",
          path: "/approvedoperations",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-alert",
          path: "/deleteoperations",
        },
        {
          title: "Training List",
          icon: "mdi-chair-school",
          path: "/traininglist",
        },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/snakereports",
        },
        {
          title: "Add Snake Experts",
          icon: "mdi-plus",
          path: "/addsnakeexperts",
        },
        {
          title: "Add Hospital",
          icon: "mdi-hospital-building",
          path: "/addhospital",
        },
        {
          title: "View Hospital",
          icon: "mdi-hospital-marker",
          path: "/Viewhospital",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-box-multiple-outline",
          path: "/identificationhelp",
        },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/excelreport",
        },
        // {
        //   title: "Approve Hospital",
        //   icon: "mdi-check-decagram-outline",
        //   path: "/approvehospital",
        // },
      ],

      dynamic: {
        title: "Dynamic Data",
        icon: "mdi-folder",
        visible: false,
        dynamicItems: [
          {
            title: "Scenerios",
            path: "/Admin/dynamicData/scenerios",
          },
          {
            title: "Animals",
            path: "/Admin/dynamicData/animals",
          },
          {
            title: "Animal Activities",
            path: "/Admin/dynamicData/animalActivities",
          },
          {
            title: "Animal Status",
            path: "/Admin/dynamicData/animalStatus",
          },
          // {
          //   title: "Animal Age",
          //   path: "/Admin/dynamicData/animalAge",
          // },
          // {
          //   title: "Veterinary Recommendation",
          //   path: "/Admin/dynamicData/veterinaryRecommendation",
          // },
          {
            title: "Mitigations",
            path: "/Admin/dynamicData/mitigationTypes",
          },
          {
            title: "Land Types",
            path: "/Admin/dynamicData/landTypes",
          },
          {
            title: "Gender",
            path: "/Admin/dynamicData/gender",
          },
          // {
          //   title: "Close Status",
          //   path: "/Admin/dynamicData/closeStatus",
          // },
          // {
          //   title: "Release Types",
          //   path: "/Admin/dynamicData/releaseTypes",
          // },
          {
            title: "Breach Types",
            path: "/Admin/dynamicData/breachType",
          },
          {
            title: "Barrier Types",
            path: "/Admin/dynamicData/barrierType",
          },
          {
            title: "Conflict Types",
            path: "/Admin/dynamicData/conflictType",
          },
          {
            title: "Crop Types",
            path: "/Admin/dynamicData/cropType",
          },
          // {
          //   title: "Assets",
          //   path: "/Admin/dynamicData/assets",
          // },
        ],
      },

      sarpa: {
        title: "SARPA",
        icon: "mdi-snake",
        visible: false,
        sarpaItems: [
          {
            title: "Dashboard",
            path: "/Sarpa/dashboard",
          },
          {
            title: "Add Snakes",
            path: "/addSnakes",
          },
          {
            title: "All Users",
            path: "/usersList",
          },
          {
            title: "New Rescuers",
            path: "/newrescuerslist",
          },
          {
            title: "Rescuer List",
            path: "/allrescuerlist",
          },
          {
            title: "Pending Operations",
            path: "/pendingoperations",
          },
          {
            title: "Assigned Operations",
            path: "/assignedoperations",
          },
          {
            title: "Rescued Operations",
            path: "/rescuedoperations",
          },
          {
            title: "Released Operations",
            path: "/releasedoperations",
          },
          {
            title: "Approved Operations",
            path: "/approvedoperations",
          },
          {
            title: "Delete Operations",
            path: "/deleteoperations",
          },
          {
            title: "Training List",
            path: "/traininglist",
          },
          {
            title: "Snake Reports",
            path: "/snakereports",
          },
          {
            title: "Add Snake Experts",
            path: "/addsnakeexperts",
          },
          {
            title: "Add Hospital",
            path: "/addhospital",
          },
          {
            title: "View Hospital",
            path: "/Viewhospital",
          },
          {
            title: "Identification Help",
            path: "/identificationhelp",
          },
          {
            title: "Approve Hospital",
            path: "/approvehospital",
          },
        ],
      },


      right: null,
      deocDialog: false,
      deocRescueDialog: false,
      showSnackBar: false,
      msg: null,
      timeout: 5000,
    };
  },
  mounted() {
    this.verifyDeocCase();
    this.verifyDeocRescueCase();
  },
  watch: {
    $route() {
      this.verifyDeocCase();
      this.verifyDeocRescueCase();
    }
  },
  methods: {
    verifyDeocCase() {
      if (this.appUser === "DEOC" && this.$route.name === "daily-reporting") {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
        axios({
          method: "GET",
          url: "/deoc_daily_report/check-entry",
          params: {
            date: today
          },
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.data.status === false) {
              this.deocDialog = true;
            } else {
              this.deocDialog = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    verifyDeocRescueCase() {
      if (this.appUser === "DEOC" && this.$route.name === "daily-reporting-rescue") {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
        axios({
          method: "GET",
          url: "/deoc_daily_rescue_report/check-entry", // To be updated to rescue endpoint
          params: {
            date: today
          },
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.data.status === false) {
              this.deocRescueDialog = true;
            } else {
              this.deocRescueDialog = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    handleDeocYes() {
      this.deocDialog = false;
      if (this.$route.name !== "daily-reporting") {
        this.$router.push("/Officers/daily-reporting").catch(() => { });
      }
    },
    handleRescueDeocYes() {
      this.deocRescueDialog = false;
      if (this.$route.name !== "daily-reporting-rescue") {
        this.$router.push("/Officers/daily-reporting-rescue").catch(() => { });
      }
    },
    handleDeocNo() {
      axios({
        method: "POST",
        url: "/deoc_daily_report/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          loggedWithACase: false,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.deocDialog = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleRescueDeocNo() {
      axios({
        method: "POST",
        url: "/deoc_daily_rescue_report/add", // To be updated to rescue endpoint
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          loggedWithACase: false,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.deocRescueDialog = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setActiveSection(section) {
      if (section === 'hwc') {
        this.$router.push('/admin/analyticspage');
      }
      if (section === 'sarpa') {
        this.$router.push('/Sarpa/dashboard');
      }
      this.activeSection = section;
      localStorage.setItem('activeSection', section); // Save to localStorage
    }
  },
  computed: {
    appUser() {
      return this.$store.state.userRole;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* ── Sidebar shell ─────────────────────────────── */
.modern-sidebar {
  background: linear-gradient(180deg, #183824 0%, #254b31 100%) !important;
  box-shadow: 4px 0 24px rgba(24, 56, 36, 0.15) !important;
  border-right: none !important;
  font-family: 'Inter', sans-serif;
  display: flex !important;
  flex-direction: column !important;
}

/* ── Logo area (fixed header, matches navbar height) */
.sidebar-logo-area {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  min-height: 60px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

/* ── Section toggle ────────────────────────────── */
.sidebar-section-toggle {
  display: flex;
  gap: 8px;
  padding: 14px 12px 10px;
}

.section-btn {
  flex: 1;
  padding: 7px 0;
  border: 1.5px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.2px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-transform: uppercase;
}

.section-btn:hover {
  background: rgba(126, 185, 95, 0.15) !important;
  border-color: rgba(126, 185, 95, 0.5) !important;
  color: #7eb95f !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 185, 95, 0.2) !important;
}

.section-btn.active {
  background: linear-gradient(135deg, #7eb95f 0%, #5d9e3b 100%) !important;
  border-color: #7eb95f !important;
  color: #102411 !important;
  box-shadow: 0 4px 16px rgba(126, 185, 95, 0.45) !important;
}

/* ── Divider ───────────────────────────────────── */
.sidebar-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
  margin: 4px 12px 8px;
}

/* ── Scrollable nav area ───────────────────────── */
.sidebar-scroll {
  overflow-y: auto;
  /* 60px logo + 14px top-pad + 44px buttons + 10px bot-pad + 1px divider + margins ≈ 176px */
  height: calc(100vh - 176px);
  flex: 1;
  padding: 4px 8px 16px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.sidebar-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

/* ── Nav items ─────────────────────────────────── */
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  margin: 2px 0;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
  transition: background 0.22s ease;
}

.sidebar-item:hover::before {
  background: rgba(255, 255, 255, 0.07);
}

/* No horizontal nudge - it made the whole list feel jittery on hover. */
.sidebar-item:hover::before {
  background: rgba(255, 255, 255, 0.09);
}

.sidebar-item:hover .sidebar-icon {
  color: #7eb95f !important;
  text-shadow: 0 0 10px rgba(126, 185, 95, 0.6) !important;
}

.sidebar-item:hover .sidebar-label {
  color: #ffffff;
}

/* Active state */
/* Softer active state: a translucent green wash with a bright left marker,
   instead of a solid lime block with near-black text. */
.sidebar-item--active {
  background: rgba(126, 185, 95, 0.16) !important;
  border: 1px solid rgba(126, 185, 95, 0.28) !important;
  box-shadow: none !important;
}

.sidebar-item--active .sidebar-icon {
  color: #9ede76 !important;
}

.sidebar-item--active .sidebar-label {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Marker on the LEFT, where the eye scans for it. */
.sidebar-item--active .sidebar-active-bar {
  display: block !important;
  position: absolute !important;
  left: 0 !important;
  top: 18% !important;
  width: 3px !important;
  height: 64% !important;
  background: #9ede76 !important;
  border-radius: 0 4px 4px 0 !important;
  box-shadow: 0 0 10px rgba(158, 222, 118, 0.55) !important;
}

.sidebar-active-bar {
  display: none;
}

/* Icon & label ────────────────────────────────── */
.sidebar-icon {
  color: rgba(255, 255, 255, 0.45) !important;
  font-size: 18px !important;
  flex-shrink: 0;
  transition: color 0.2s ease, text-shadow 0.2s ease;
}

.sidebar-label {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s ease;
}

/* Child items (nested) ────────────────────────── */
.sidebar-item--child {
  padding-left: 22px;
}

.sidebar-item--child .sidebar-label {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.5);
}

/* Vuetify list-group override inside sidebar ──── */
.sidebar-group .v-list-group__header {
  padding: 0 !important;
  min-height: unset !important;
  background: transparent !important;
}

.sidebar-group .v-list-group__items {
  background: transparent !important;
}

.group-activator {
  width: 100%;
}
</style>
